import { render, staticRenderFns } from "./Jobs1.vue?vue&type=template&id=2933d0ad"
import script from "./Jobs1.vue?vue&type=script&lang=ts"
export * from "./Jobs1.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports